import { GridPosition } from '~/types/drill'

export function getGridPosition(index: number): GridPosition {
  let colPosition = [0, 0]
  let rowPosition = [0, 0]

  switch (index) {
    case 0:
      colPosition = [3, 5]
      rowPosition = [1, 3]
      break

    case 1:
      colPosition = [4, 6]
      rowPosition = [3, 5]
      break

    case 2:
      colPosition = [6, 8]
      rowPosition = [3, 5]
      break

    case 3:
      colPosition = [7, 9]
      rowPosition = [1, 3]
      break

    default:
      break
  }

  return {
    gridColumnStart: colPosition[0],
    gridColumnEnd: colPosition[1],
    gridRowStart: rowPosition[0],
    gridRowEnd: rowPosition[1],
  }
}
